import { Component, Input, ViewEncapsulation, ViewChildren, QueryList, ViewChild } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { element } from 'protractor';

import { HttpClient } from '@angular/common/http';
import { HttpErrorResponse } from '@angular/common/http';
//import { ToasterModule, ToasterService, ToasterConfig } from 'angular2-toaster';
import { FormGroup, FormBuilder, Validators, FormControl, AbstractControl, FormGroupName } from '@angular/forms';
import { ValidationFormsService } from './validation-forms.service';
import { ValidatorFn, ValidationErrors } from '@angular/forms';
import { ToasterComponent, ToasterPosition } from '@coreui/angular';
import { AppToastComponent as ToastComp } from '../../../services/shared-service/toast-simple/toast.component'
import { HttpService } from '../../../services/http-service/http.service'
import { ValidationService } from '../../../services/validation-service/validation.service';
import { ModalDirective } from 'ngx-bootstrap/modal';

import { ToastrService } from 'ngx-toastr';
import { LocalInterfaceService } from '../../../services/local-inteface-service/local-interface.service';
import { StorageService } from '../../../services/storege-service/storage.service';
import * as moment from 'moment';
import { ToolService } from '../../../services/tool/tool.service';

@Component({
  //selector: 'app-toasters',
  templateUrl: 'basic-forms.component.html',
  styleUrls: ["../../../../../node_modules/ngx-bootstrap/datepicker/bs-datepicker.css",],
  //encapsulation: ViewEncapsulation.None,
  providers: [ValidationFormsService]
})


export class BasicFormsComponent {
  minDate = new Date(2017, 5, 10);
  maxDate = new Date(2022, 9, 15);

  bsValue: Date = new Date();

  // Timepicker

  public isEnabled: boolean = true;


  public mfData?: object = {};
  public courts?;
  public users?;
  public types?;
  public facilities?;
  isUpdate: boolean = false;
  dbFunction?: string;
  facilityId: string;
  coachId: string;
  nameEn: string;
  nameAr: string;
  descriptionEn: string;
  descriptionAr: string;
  whatsappLink: string;
  instagramLink: string;
  countryCode: string;
  mobile: string;
  sort: string;
  startDate: string;
  endDate: string;
  showInApp: string;
  facilityCountryCode: string;

  gapBetweenFacilities: string;
  gapBetweenSessions: string;
  maxTimeAllowedInRow: string;
  maxTimeAllowedInDay: string;

  uploadedImage: File;
  base64Image: string;
  profileImage: string;
  status: string;
  public isLoading = false;

  isError: boolean = false;

  simpleForm: FormGroup;
  submitted = false;
  formErrors: any;

  //private toasterService: ToasterService;
  //public toasterconfig: ToasterConfig = new ToasterConfig({tapToDismiss: true, timeout: 5000});

  @ViewChild(ToastComp) toastComp: ToastComp;
  @ViewChild('resetModal', { static: false }) public resetModal: ModalDirective;

  public paddingStyle: Object = { 'padding-right': '20px' };


  constructor(
    private router: Router,
    private http: HttpClient,
    public route: ActivatedRoute,
    private fb: FormBuilder,
    public vf: ValidationFormsService,
    public httpService: HttpService,
    private toastr: ToastrService,
    private localInterfaceSrv: LocalInterfaceService,
    private validationSrv: ValidationService,
    private storageSrv: StorageService,
    public toolService: ToolService,
  ) {
    //if (localStorage.getItem('currentUser') === null) {this.router.navigateByUrl('/login');}
    if (localStorage.getItem('lang') === "ar") {
      //this.toasterconfig = new ToasterConfig({tapToDismiss: true, timeout: 5000, positionClass: 'toast-top-left'});
    }
    //this.toasterService = toasterService;
    this.formErrors = this.vf.errorMessages;

    this.facilityCountryCode = this.storageSrv.getFacilityCountryCode();

    if (this.router.getCurrentNavigation().extras.state?.createData == null) {
      this.isUpdate = true;
      this.dbFunction = 'updateUsersTable';
      this.mfData = this.router.getCurrentNavigation().extras.state?.data;
      this.coachId = this.mfData['id'];
      this.facilityId = this.mfData['facilityIds']?.split(',');
      this.nameEn = this.mfData['nameEn'];
      this.nameAr = this.mfData['nameAr'];
      this.descriptionEn = this.mfData['descriptionEn'];
      this.descriptionAr = this.mfData['descriptionAr'];
      this.whatsappLink = this.mfData['whatsappLink'];
      this.instagramLink = this.mfData['instagramLink'];
      this.countryCode = this.mfData['countryCode'];
      this.mobile = this.mfData['mobile'];
      this.sort = this.mfData['sort'];
      this.gapBetweenFacilities = this.mfData['gapBetweenFacilities'];
      this.gapBetweenSessions = this.mfData['gapBetweenSessions'];
      this.maxTimeAllowedInRow = this.mfData['maxTimeAllowedInRow'];
      this.maxTimeAllowedInDay = this.mfData['maxTimeAllowedInDay'];
      this.startDate = this.mfData['startDate'] != null ? new Date(this.mfData['startDate'].replace(/-/g, "/")) : this.mfData['startDate'];
      this.endDate = this.mfData['endDate'] != null ? new Date(this.mfData['endDate'].replace(/-/g, "/")) : this.mfData['endDate'];
      this.showInApp = this.mfData['showInApp'];
      this.profileImage = this.mfData['profileImage'];
      this.status = this.mfData['status'];
    }
    else {
      this.dbFunction = '/addBooking';
      this.coachId = '';
      this.facilityId = '';
      this.nameEn = '';
      this.nameAr = '';
      this.descriptionEn = '';
      this.descriptionAr = '';
      this.whatsappLink = '';
      this.instagramLink = '';
      this.sort = '';
      this.gapBetweenFacilities = '';
      this.gapBetweenSessions = '';
      this.maxTimeAllowedInRow = '';
      this.maxTimeAllowedInDay = '';
      this.startDate = '';
      this.endDate = '';
      this.profileImage = '';
      this.mobile = '';
      this.countryCode = '';
      this.showInApp = '';
      this.status = '';
    }
    this.simpleForm = this.fb.group({});
    // this.loadUserTypes();
    // this.createForm();
  }

  ngOnInit(): void {
    this.validationSrv.validateAcess()
      .then(async () => {
        this.isLoading = true;
        this.route.queryParams.subscribe(async params => {
          await this.loadActiveFacilities();
          await this.createForm();
        });
      });
  }

  isCollapsed: boolean = false;
  iconCollapse: string = 'icon-arrow-up';

  @Input() message: string;
  messages: string[] = [];
  updatedData = this.mfData;

  createForm() {
    this.simpleForm = this.fb.group({
      coachId: [this.coachId, [Validators.required]],
      facilityId: [this.facilityId, [Validators.required]],
      mobile: { value: this.mobile, disabled: this.isUpdate ? true : false },
      countryCode: { value: this.countryCode, disabled: this.isUpdate ? true : false },
      nameEn: [this.nameEn, [Validators.required]],
      nameAr: [this.nameAr],
      descriptionEn: [this.descriptionEn],
      descriptionAr: [this.descriptionAr],
      whatsappLink: [this.whatsappLink],
      instagramLink: [this.instagramLink],
      gapBetweenFacilities: [this.gapBetweenFacilities],
      gapBetweenSessions: [this.gapBetweenSessions],
      maxTimeAllowedInRow: [this.maxTimeAllowedInRow],
      maxTimeAllowedInDay: [this.maxTimeAllowedInDay],
      startDate: [this.startDate],
      endDate: [this.endDate],
      sort: [this.sort],
      showInApp: [this.showInApp],
      profileImage: [this.profileImage],
      status: [this.status],
    }, {});
  }
  get f() { return this.simpleForm.controls; }


  async showSuccess(msg) {

    await this.toastr.success(msg, 'Success');

    if (this.isUpdate && !this.isError) {
      this.delay(2000).then(any => {
        this.router.navigate(['../'], { relativeTo: this.route }).then(() => {
          //window.location.reload();
        });;
      });
    }
    else if (!this.isUpdate && this.isError == false) {
      this.delay(2000).then(any => {
        this.router.navigate(['../'], { relativeTo: this.route }).then(() => {
          //window.location.reload();
        });;
      });
    }
  }

  public findInvalidControls() {
    const invalid = [];
    const controls = this.simpleForm.controls;
    for (const name in controls) {
      if (controls[name].invalid) {
        invalid.push(name);
      }
    }
    return invalid;
  }

  uploadFile(event) {
    let files = event.target.files;
    const reader = new FileReader();
    if (files.length > 0) {
      this.uploadedImage = files[0]; // You will see the file
      reader.readAsDataURL(this.uploadedImage);
      reader.onload = (_event) => {
        this.profileImage = reader.result.toString();
      }
    }
  }

  saveCoach = () => {

    if (this.uploadedImage != null) {
      this.base64Image = this.profileImage;
      this.simpleForm.controls['profileImage'].setValue(this.uploadedImage.name);
    }

    let formattedStartDate = (moment(new Date(this.f['startDate'].value))).format('YYYY-MM-DD');
    let formattedEndDate = (moment(new Date(this.f['endDate'].value))).format('YYYY-MM-DD');

    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      const fields = {
        coachId: this.mfData['id'],
        coachConfigId: this.mfData['coachConfigId'],
        facilityIds: this.f['facilityId'].value.toString(),
        mobile: this.f['mobile'].value,
        countryCode: this.f['countryCode'].value,
        nameEn: this.f['nameEn'].value,
        nameAr: this.f['nameAr'].value,
        descriptionEn: this.f['descriptionEn'].value,
        descriptionAr: this.f['descriptionAr'].value,
        whatsappLink: this.f['whatsappLink'].value,
        instagramLink: this.f['instagramLink'].value,
        gapBetweenFacilities: this.f['gapBetweenFacilities'].value,
        gapBetweenSessions: this.f['gapBetweenSessions'].value,
        maxTimeAllowedInRow: this.f['maxTimeAllowedInRow'].value,
        maxTimeAllowedInDay: this.f['maxTimeAllowedInDay'].value,
        startDate: formattedStartDate,
        endDate: formattedEndDate,
        sort: this.f['sort'].value,
        showInApp: this.f['showInApp'].value,
        profileImage: this.base64Image,
        status: this.f['status'].value,
      };
      if (this.isUpdate) {
        this.localInterfaceSrv.updateCoach(fields)
          .then(async res => {
            resolve(res);
            this.showSuccess('Coach Updated');
          })
          .catch(err => {
            reject(err);
            this.toastr.error(err.description, "Error");
          })
          .finally(() => this.isLoading = false);
      }
      else {
        this.localInterfaceSrv.addCoach(fields)
          .then(async res => {
            resolve(res);
            this.showSuccess('Coach Added');
          })
          .catch(err => {
            reject(err);
            this.toastr.error(err.description, "Error");
          })
          .finally(() => this.isLoading = false);
      }
    });
  }

  async delay(ms: number) {
    //await new Promise(resolve => setTimeout(()=>resolve(), ms)).then(()=>this.toolService.showConsoleLog("fired"));
  }

  collapsed(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  updateData(name: string): void {
    this.updateData['nameEn'] = name;
  }


  expanded(event: any): void {
    // this.toolService.showConsoleLog(event);
  }

  toggleCollapse(): void {
    this.isCollapsed = !this.isCollapsed;
    this.iconCollapse = this.isCollapsed ? 'icon-arrow-down' : 'icon-arrow-up';
  }

  resetPassword = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.resetUserPassword(this.mfData['id'])
        .then(async res => {
          resolve(res);
          this.showSuccess('Password has been reset');
        })
        .catch(err => {
          reject(err);
          this.toastr.error(err.description, "Error");
        })
        .finally(() => this.isLoading = false);
    });
  }
  loadActiveFacilities = () => {
    return new Promise<any>(async (resolve, reject) => {
      this.isLoading = true;
      this.localInterfaceSrv.getActiveFacilitiesBranches()
        .then(res => {
          this.facilities = res.content;
          resolve(res);
        })
        .catch(err => {
          reject(err);
          this.toolService.showConsoleLog(err)
          this.toastr.error(err.description, "Error");
        })
        .finally(() => { this.isLoading = false; });
    });
  }

}
